import React from 'react';

import getYear from 'date-fns/get_year';

const ZegoCopyright = () => (
  <React.Fragment>© Zego {getYear(new Date())}</React.Fragment>
);
export default ZegoCopyright;
